const DEFAULT_DURATION_MS = 950;
const DEFAULT_OFFSET_PX = 0;
let activeScrollFrame = null;
let restoreScrollBehavior = null;

const easeInOutCubic = (progress) => (
  progress < 0.5
    ? 4 * progress * progress * progress
    : 1 - ((-2 * progress + 2) ** 3) / 2
);

const setScrollTop = (top) => {
  window.scrollTo({ top, left: 0, behavior: 'auto' });
};

const cancelActiveScroll = () => {
  if (activeScrollFrame !== null) {
    window.cancelAnimationFrame(activeScrollFrame);
    activeScrollFrame = null;
  }
  if (restoreScrollBehavior) {
    restoreScrollBehavior();
  }
};

const forceManualScrollBehavior = () => {
  const root = document.documentElement;
  const previousScrollBehavior = root.style.scrollBehavior;
  root.style.scrollBehavior = 'auto';
  restoreScrollBehavior = () => {
    root.style.scrollBehavior = previousScrollBehavior;
    restoreScrollBehavior = null;
  };
};

export const smoothScrollToElement = (selector, options = {}) => {
  const element = typeof selector === 'string' ? document.querySelector(selector) : selector;
  if (!element) {
    return;
  }

  const isHomeTarget = selector === '#home' || element.id === 'home';
  const targetY = Math.max(
    0,
    element.getBoundingClientRect().top + window.scrollY - (isHomeTarget ? 0 : (options.offset ?? DEFAULT_OFFSET_PX))
  );

  cancelActiveScroll();
  forceManualScrollBehavior();

  if (options.instant) {
    setScrollTop(targetY);
    if (restoreScrollBehavior) {
      restoreScrollBehavior();
    }
    return;
  }

  const startY = window.scrollY;
  const distance = targetY - startY;
  if (Math.abs(distance) < 2) {
    setScrollTop(targetY);
    if (restoreScrollBehavior) {
      restoreScrollBehavior();
    }
    return;
  }

  const duration = options.duration ?? DEFAULT_DURATION_MS;
  const startedAt = performance.now();

  const step = (now) => {
    const elapsed = now - startedAt;
    const progress = Math.min(1, elapsed / duration);
    setScrollTop(startY + distance * easeInOutCubic(progress));

    if (progress < 1) {
      activeScrollFrame = window.requestAnimationFrame(step);
      return;
    }

    activeScrollFrame = null;
    setScrollTop(targetY);
    if (restoreScrollBehavior) {
      restoreScrollBehavior();
    }
  };

  step(startedAt + 16);
};
